import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

import {
    EXERCISE_CALCULATION,
    EXERCISE_LOGIC,
    EXERCISE_MAGIC_BOX,
    EXERCISE_PUZZLE_TASK,
    EXERCISE_PUZZLE_EXAMPLE,
    EXERCISE_SEQUENCE,
    EXERCISE_TASK,
    KATEX_FORMAT
} from '@app/app.constants';
import { Currency, MinifiedBox } from '@df/interfaces';
import { declensionOfNumerals } from '@app/_utils/helpers';
import { AnalyticService } from '@app/teacher/services/analytic.service';
import { TaskService } from '@app/core/services/task.service';
import { IExercise } from '@df/interfaces/exercise';

@Component({
    selector: 'app-common-modal',
    templateUrl: './common-modal.component.html',
    styleUrls: ['../../../../../_pipes/exercise-format.pipe.scss', './common-modal.component.scss']
})
export class CommonModalComponent implements OnInit, OnDestroy {
    @Input() box: MinifiedBox;
    @Input() student_id;
    @Output() shouldClose = new EventEmitter();

    currency: Currency;
    responseResult: any = null;
    logic: string = EXERCISE_LOGIC;
    calculation: string = EXERCISE_CALCULATION;
    magic_box: string = EXERCISE_MAGIC_BOX;
    task: string = EXERCISE_TASK;
    sequence: string = EXERCISE_SEQUENCE;
    puzzle_task: string = EXERCISE_PUZZLE_TASK;
    puzzle_example: string = EXERCISE_PUZZLE_EXAMPLE;

    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(private analyticService: AnalyticService, private taskService: TaskService) {}

    public ngOnInit(): void {
        this.getModalData(this.student_id, this.box.id);
    }

    public ngOnDestroy(): void {
        this.destroy$.next(true);
    }

    closeModal() {
        this.shouldClose.emit(true);
    }

    getModalData(student, box) {
        this.analyticService
            .getStudentBoxesAnalytics(student, box)
            .pipe(takeUntil(this.destroy$))
            .subscribe(response => {
                console.log(response);
                this.responseResult = response;
                this.currency = response.currency;
                this.sortCards(this.responseResult);
            });
    }

    getCardStyle(format) {
        switch (format) {
            case 'A5':
                return 'box-cards-a5';
            case 'A6':
                return 'box-cards-a6';
            case 'A7':
                return 'box-cards-a7';
            case 'A3':
                return 'box-cards-a3';
        }
    }

    removeUnnecessaryInput(answer) {
        const reUnnecessary = /\(.*?\)/g;
        return answer.replace(reUnnecessary, '').trim();
    }

    isAnswerCorrect(exercise): boolean {
        const fullAnswer = exercise.exercise_correct_answers[0].shortAnswer;
        const shortAnswer = this.removeUnnecessaryInput(fullAnswer);
        return exercise.shortAnswer === shortAnswer || exercise.shortAnswer === fullAnswer;
    }

    getMoneyAmount(instAmount) {
        const amount = parseFloat(instAmount);
        const kairos = true;
        let cur_str = declensionOfNumerals(amount, this.currency, kairos);
        if (this.currency) {
            cur_str = declensionOfNumerals(amount, this.currency);
        }
        if (amount === 0) {
            return '';
        } else {
            return '' + amount + ' ' + cur_str;
        }
    }

    sortCards(response) {
        response.cards_results.sort((card1, card2): number => {
            return card1.card_number > card2.card_number ? 1 : -1;
        });
    }

    getTaskSpacingStyle(i) {
        return i > 0 ? '' : 'exercise-spacing';
    }

    getMagicBoxObject(string) {
        return JSON.parse(string);
    }

    getMagicBoxCellRight(exercise, row_index, elem_index) {
        return this.getMagicBoxObject(exercise.exercise_correct_answers[0].shortAnswer)[row_index][elem_index];
    }

    getMagicBoxCellWrong(exercise, row_index, elem_index) {
        return this.getMagicBoxObject(exercise.shortAnswer)[row_index][elem_index];
    }

    compareMagicBoxAnswers(exercise, row_index: number, elem_index: number) {
        if (
            this.getMagicBoxObject(exercise.shortAnswer)[row_index][elem_index] ===
            this.getMagicBoxObject(exercise.exercise_correct_answers[0].shortAnswer)[row_index][elem_index]
        ) {
            return true;
        }
        return false;
    }

    getMagicBoxTdStyle(elem, exercise, row_index, elem_index) {
        if (elem == null) {
            if (this.compareMagicBoxAnswers(exercise, row_index, elem_index)) {
                return 'magic-box-border-right';
            }
            return 'magic-box-border-wrong';
        }
        return '';
    }

    convertSecondToMinute(card: any) {
        const cardDuration = this.taskService.converSecondsToMinuteString(card.duration);
        return cardDuration;
    }

    isKatexFormat(exercise: IExercise): boolean {
        return exercise.format_type === KATEX_FORMAT;
    }
}
